const KEY = 'robotrons:playerId';

// A refresh hands the browser a brand new socket id, which used to make the
// server treat the returning player as a stranger (bid, score and demo turn
// all lost). sessionStorage survives a reload but is per-tab, so two tabs on
// one browser still count as two players.
export function getPlayerId() {
  let id = null;
  try {
    id = sessionStorage.getItem(KEY);
    if (!id) {
      id = (window.crypto?.randomUUID?.())
        ?? `p-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(KEY, id);
    }
  } catch (e) {
    // Private mode / storage disabled — fall back to socket-id identity.
  }
  return id;
}

// The server refuses a kicked playerId for as long as the room lives, so the
// way back in is a new identity. Dropping the stored id makes the next
// getPlayerId() mint one — which is why re-entering from the menu works and an
// abandoned tab reconnecting on its own does not.
export function rotatePlayerId() {
  try {
    sessionStorage.removeItem(KEY);
  } catch (e) {
    // Nothing stored to begin with; getPlayerId() already falls back.
  }
  return getPlayerId();
}
